// extracted by mini-css-extract-plugin
export default {"authenticatorAppSetupSteps":"J0hiwlDVcvkr09zgy1sZ"};